import { render, staticRenderFns } from "./charityReportsRoot.vue?vue&type=template&id=253c85be&"
import script from "./charityReportsRoot.vue?vue&type=script&lang=js&"
export * from "./charityReportsRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports